import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box,TextField as MuiTextField, } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, request, toast } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ITEM_WISE_SALE_REPORT, PHARMACY_REPORT_TYPE } from '../../../../../constants/dropdown';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';
import { SelectDoctorTable } from '../../HMS/masters/others/SelectDoctorTable';


  const PRODUCT_HEADER = [{ header: 'Product Name', accessor: (row) => row?.main?.name }].filter(Boolean);

export const Itemwisesalereortregister = () => {
  const { pathname } = useLocation();
  const [productDropdown, setProductDropdown] = useState([]);
  const [selectedRows,setSelectedRows] = useState([])
  const [input,setInput] = useState('')
  const [productids, setProductIds] = useState('');

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required('From date is required'),
        to_date: Yup.string().required('To date is required')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0], 
      to_date: new Date().toISOString().split('T')[0] 
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;

  const onSubmit = () => {
    const productId = watch('product');
    const startDate = watch('from_date');
    const endDate = watch('to_date');
    const url = `/print${pathname}?productId=${encodeURIComponent(productId)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
    console.log('Generated URL:', url);
    window.open(url, '_blank');
  };

  const getProductDropdown = useCallback(async () => {
    const data = await axios.get(`${BASE_URL}/product-master/dropdown?limit=${10}`);
    if (data?.data.data) {
      setProductDropdown(data.data.data);
    }
  }, []);

  useEffect(() => {
    getProductDropdown();
  }, []);


  const isSelected = (row, field) => {
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      return false;
    }
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };


  const handleChange =(e)=>{
    setInput(e.target.value)
  }

    const searchProducts = useCallback(async () => {
    const lowercasedInput = String(input).toLowerCase();
    const response = await axios.get(`${BASE_URL}/product-master/dropdown?name=${lowercasedInput}&limit=${10}`);
    setProductDropdown(response.data.data);
  }, [input]);

  useEffect(()=>{
    searchProducts();
  },[input])

useEffect(() => {
        const ids = selectedRows.map((item) => item._id).join(',');
        setProductIds(ids);
}, [ selectedRows]);

console.log(productids,"PRODUCT IDS IS HERRE ")
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Item Wise Sale Report Register
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({
                        productId: productids,
                        from_date: watch('from_date'),
                        to_date: watch('to_date'),
                        report_type:watch('report_type')
                      })}`,
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained" onClick={() => reset()}>
                  Exit
                </Button>
              </Stack>
            </Stack>

    
            <Grid container spacing={2}>
              <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Report Type</Typography>
                  <SelectTag formControlSX={{ flex: 0.8 }} name="report_type"  menus={ITEM_WISE_SALE_REPORT}/>
                </Stack>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{marginTop:"2%"}}>
   <MuiTextField
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  padding: '0',
                  fontSize: '1.4rem'
                },
                '& .MuiOutlinedInput-input': {
                  padding: '8px 1.4rem'
                },
                '& .MuiInputLabel-root': {
                  fontSize: '1.2rem'
                }
              }}
              label="Search By Product Name"
              variant="outlined"
              value={input}
              onChange={handleChange}
            />
            <SelectDoctorTable
              containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
              data={productDropdown || []}
              columns={PRODUCT_HEADER}
              size="small"
              showInputField={true}
              showOk={true}
              isSelected={isSelected}
              handleRowSelect={handleRowSelect}
              currentAction={'new'}
              selectedRows={selectedRows}
            />
            </Grid>
         
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
